export default {
  dataIterator: {
    rowsPerPageText: 'Nb. par page :',
    rowsPerPageAll: 'Tous',
    pageText: '{0}-{1} sur {2}',
    noResultsText: 'Aucun résultat',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente'
  },
  dataTable: {
    rowsPerPageText: 'Lignes par page :'
  },
  noDataText: 'Pas de donnée'
}
